import React from "react";

import { MessageTheme } from "types";

import { i18nService } from "services";
import { Message } from "components/message/Message";

interface ToolSearchMessageProps {
  nbItems?: number;
  isError?: boolean;
  hasSearched?: boolean;
  clearAllFacets?: () => void;
  noResultMessage: string;
}

export const ToolSearchMessage: React.FC<ToolSearchMessageProps> = ({
  nbItems,
  isError,
  hasSearched,
  clearAllFacets,
  noResultMessage,
}) => {
  if (isError) {
    return (
      <Message theme={MessageTheme.error}>
        {i18nService.copy["toolSearch.error"]}
      </Message>
    );
  }

  return (
    <>
      {!!nbItems && (
        <span className="text is-meta">
          {i18nService.copy[
            nbItems === 1
              ? "toolSearch.nbResultsSingular"
              : "toolSearch.nbResults"
          ]?.replace("@number", String(nbItems))}
        </span>
      )}
      {!isError && !nbItems && hasSearched && (
        <Message theme={MessageTheme.error}>
          <div
            className="active-facets__no-results"
            dangerouslySetInnerHTML={{ __html: noResultMessage }}
          ></div>

          <button
            className="active-facets__remove"
            type="button"
            onClick={clearAllFacets}
          >
            {i18nService.copy["facets.removeAllFacets"]}
          </button>
        </Message>
      )}
    </>
  );
};
